import { VenueDateBasic } from '@/domain/project-venue-dates/entities/project-venue-dates.entity';
import { SnackbarGateway } from '@/domain/snackbar/gateways/snackbar.gateway';
import { createAppAsyncThunk } from '@/domain/store.thunk';
import { translate } from '@/ui/i18n';

type Params = {
  username: string;
  password: string;
  startDate: string;
  endDate: string;
};

type Result = VenueDateBasic[];

export const importVenueDatesFromHeeds = createAppAsyncThunk(
  'projectVenueDates/importVenueDatesFromHeeds',
  async (
    params: Params,
    { extra: { projectVenueDatesGateway, snackbarGateway } },
  ): Promise<Result> => {
    let importedDates: VenueDateBasic[];
    try {
      importedDates = await projectVenueDatesGateway.importDatesFromHeeds(
        params.username,
        params.password,
        params.startDate,
        params.endDate,
      );
    } catch (error) {
      showSnackbarError(snackbarGateway);
      throw error;
    }
    return importedDates;
  },
);

function showSnackbarError(snackbarGateway: SnackbarGateway) {
  snackbarGateway.error(translate('ImportVenueDates.Message.error'));
}
